import React from 'react';
import { Link } from 'react-router-dom';
import { MonoLabel, EditorialButton, SectionCap } from '../components/Editorial';

export default function HomePage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--ed-surface-soft)' }}>
      <nav style={{
        background: 'var(--ed-slate-1)',
        padding: '16px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <img src="/logo.png" alt="ProZpects" style={{ height: 32 }} />
        <div style={{ display: 'flex', gap: 12 }}>
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <EditorialButton variant="ghost">Log In</EditorialButton>
          </Link>
          <Link to="/register" style={{ textDecoration: 'none' }}>
            <EditorialButton variant="solid">Sign Up</EditorialButton>
          </Link>
        </div>
      </nav>

      <section style={{
        background: `
          radial-gradient(120% 140% at 90% 10%, rgba(110, 84, 184, 0.25), transparent 55%),
          radial-gradient(120% 140% at 0% 100%, rgba(255, 122, 69, 0.10), transparent 55%),
          linear-gradient(135deg, var(--ed-slate-1) 0%, var(--ed-slate-2) 55%, var(--ed-slate-3) 100%)
        `,
        color: 'var(--ed-on-dark)',
        padding: '80px 32px',
      }}>
        <div style={{ maxWidth: 1140, margin: '0 auto' }}>
          <MonoLabel onDark>RECRUITING · VERIFIED</MonoLabel>
          <h1 style={{
            fontFamily: 'var(--ed-font-serif)',
            fontWeight: 400,
            fontSize: 'clamp(48px, 8vw, 96px)',
            lineHeight: 1.02,
            letterSpacing: '-0.02em',
            margin: '24px 0 24px',
            maxWidth: 900,
          }}>
            Where the recruiting{' '}
            <span style={{ fontStyle: 'italic' }}>tape stops talking,</span>
            {' '}<span style={{ fontStyle: 'italic' }}>and the data starts.</span>
          </h1>
          <p style={{
            maxWidth: 600,
            fontSize: 18,
            lineHeight: 1.55,
            color: 'var(--ed-on-dark-muted)',
            marginBottom: 32,
          }}>
            ProZpects connects student athletes with college coaches through trusted, verified performance data — so the right players get found.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Link to="/register" style={{ textDecoration: 'none' }}>
              <EditorialButton variant="solid">Create Free Account</EditorialButton>
            </Link>
            <Link to="/login" style={{ textDecoration: 'none' }}>
              <EditorialButton variant="ghost">Coach Login</EditorialButton>
            </Link>
          </div>
        </div>
      </section>

      <section style={{ padding: '64px 32px' }}>
        <div style={{ maxWidth: 1140, margin: '0 auto' }}>
          <SectionCap label="Why ProZpects" hint="THE PITCH" />
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 16,
          }}>
            {[
              { cap: 'DATA', title: 'Verified Data', body: 'All athletic measurables verified through ProZpects showcases.' },
              { cap: 'SEARCH', title: 'Efficient Search', body: 'Coaches quickly find athletes matching exact criteria.' },
              { cap: 'COMMS', title: 'Direct Communication', body: 'Connect athletes with college programs securely.' },
              { cap: 'FOCUS', title: 'Football First', body: 'Specialized platform for football recruiting, with room to grow.' },
            ].map((f) => (
              <div key={f.title} className="ed-card">
                <MonoLabel>{f.cap}</MonoLabel>
                <h3 className="ed-card__title">{f.title}</h3>
                <p className="ed-card__body">{f.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{
        background: 'var(--ed-slate-1)',
        color: 'var(--ed-on-dark)',
        padding: '80px 32px',
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
          <MonoLabel onDark>READY?</MonoLabel>
          <h2 style={{
            fontFamily: 'var(--ed-font-serif)',
            fontWeight: 400,
            fontSize: 'clamp(36px, 5vw, 64px)',
            lineHeight: 1.05,
            letterSpacing: '-0.015em',
            margin: '24px 0 16px',
          }}>
            Build your <span style={{ fontStyle: 'italic' }}>verified profile.</span>
          </h2>
          <p style={{
            fontSize: 16,
            lineHeight: 1.55,
            color: 'var(--ed-on-dark-muted)',
            marginBottom: 24,
          }}>
            Free to start. Verified at camp. Visible to coaches.
          </p>
          <Link to="/register" style={{ textDecoration: 'none' }}>
            <EditorialButton variant="solid">Sign Up Now</EditorialButton>
          </Link>
        </div>
      </section>

      <footer style={{
        background: 'var(--ed-slate-1)',
        color: 'var(--ed-on-dark-muted)',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '24px 32px',
        fontSize: 13,
      }}>
        <div style={{ maxWidth: 1140, margin: '0 auto', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <span>&copy; 2026 ProZpects Recruiting Solutions LLC. All rights reserved.</span>
          <Link to="/privacy" style={{ color: 'var(--ed-on-dark-muted)', textDecoration: 'none' }}>Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
}
